module.exports = __webpack_public_path__ + "static/img/chargenow.5612c95c.png";